// extracted by mini-css-extract-plugin
export default {"slider":"_3QUcl","slider-short":"_99248","sliderShort":"_99248","slider-adoptables":"_3SeSH","sliderAdoptables":"_3SeSH","slider-item":"_3hpO5","sliderItem":"_3hpO5"};